import { ContactPerson } from '@iss/libs/graphql';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';

import { ContactPersonComponent } from './contact-person';

import { DeepPartial } from '@iss/wo-common/types';
import { HorizontalLineComponent } from '@iss/core/horizontal-line';

@Component({
  selector: 'wo-contact-people',
  templateUrl: './contact-people.component.html',
  styleUrls: [ './contact-people.component.scss' ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ContactPersonComponent,
    HorizontalLineComponent,
    NgForOf,
    NgIf,
  ],
})
export class ContactPeopleComponent {
  @Input() public people?: readonly DeepPartial<ContactPerson>[] | null;
}
